import React, { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";

const PENDING = [{ id: "EP-2018", product: "Wedding Cards × 250", vendor: "Signature Studio" }];
const HISTORY = [
  { id: "EP-2006", product: "Product Packaging Boxes × 500", vendor: "Bhairo Prints", rating: 5, text: "Delivered a day early, quality on point.", reply: "Thanks Ravi!" },
];

export default function CustomerReviews() {
  const [tab, setTab] = useState("pending");
  const [rating, setRating] = useState(5);
  const [text, setText] = useState("");

  return (
    <div data-testid="customer-reviews">
      <h1 className="font-display text-3xl font-bold">Reviews</h1>
      <div className="mt-3 flex gap-2">
        {[["pending", "To Review"], ["mine", "My Reviews"]].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} className={`rounded-full border px-3 py-1 text-xs font-semibold ${tab === k ? "border-neutral-900 bg-neutral-950 text-white" : "border-neutral-200 hover:border-neutral-900"}`} data-testid={`reviews-tab-${k}`}>{l}</button>
        ))}
      </div>

      {tab === "pending" && (
        <div className="mt-4 space-y-3">
          {PENDING.map((p) => (
            <div key={p.id} className="rounded-lg border border-neutral-200 bg-white p-5" data-testid={`review-pending-${p.id}`}>
              <div className="font-mono text-xs text-neutral-500">{p.id}</div>
              <div className="mt-1 font-display text-lg font-bold">{p.product}</div>
              <div className="text-xs text-neutral-500">Vendor: {p.vendor}</div>

              <div className="mt-3 flex items-center gap-1">
                {[1, 2, 3, 4, 5].map((n) => (
                  <button key={n} onClick={() => setRating(n)} data-testid={`review-star-${n}`}><Star size={22} fill={n <= rating ? "currentColor" : "none"} className={n <= rating ? "text-lime-500" : "text-neutral-300"} /></button>
                ))}
              </div>
              <textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} placeholder="Share your experience…" className="mt-3 w-full rounded-md border border-neutral-300 px-3 py-2 text-sm focus:border-neutral-900 focus:outline-none focus:ring-2 focus:ring-lime-400" data-testid="review-text" />
              <button onClick={() => { toast.success("Review submitted"); setText(""); }} className="btn-offset mt-3 rounded-md bg-lime-400 px-4 py-2 text-sm font-bold text-neutral-950 hover:bg-lime-300" data-testid="review-submit">Submit review</button>
            </div>
          ))}
        </div>
      )}

      {tab === "mine" && (
        <div className="mt-4 space-y-3">
          {HISTORY.map((h) => (
            <div key={h.id} className="rounded-lg border border-neutral-200 bg-white p-5" data-testid={`review-mine-${h.id}`}>
              <div className="font-mono text-xs text-neutral-500">{h.id}</div>
              <div className="mt-1 font-display text-lg font-bold">{h.product}</div>
              <div className="mt-2 flex text-lime-500">{[...Array(h.rating)].map((_, i) => <Star key={i} size={14} fill="currentColor" strokeWidth={0} />)}</div>
              <p className="mt-2 text-sm">"{h.text}"</p>
              <div className="mt-3 rounded-md border-l-2 border-lime-500 bg-neutral-50 px-3 py-2 text-xs"><b>{h.vendor}:</b> {h.reply}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
